
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'
import RefundModal from '../components/RefundConfirmModal.vue'
import { CustomerInvoice } from '../../global/models'

@Component({
  components: {
    RefundModal
  }
})
export default class CustomerInvoiceReadPage extends Vue {
  loading = false

  invoice: CustomerInvoice | null = null

  error: string | null = null

  get hasPdf() {
    return this.invoice && !!this.invoice.pdfPath
  }

  get hasReceipt() {
    return this.invoice && !!this.invoice.receiptPdfPath
  }

  get canRefundInvoice() {
    return !this.loading && !!this.invoice && this.invoice.status === 'paid'
  }

  get canDownloadInvoice() {
    return !this.loading && this.hasPdf
  }

  get canDownloadReceipt() {
    return !this.loading && this.hasReceipt
  }

  get invoiceId() {
    return this.$route.params.id
  }

  get refundModal() {
    return this.$refs.refundModal as RefundModal
  }

  mounted() {
    this.getInvoice()
  }

  async getInvoice() {
    this.loading = true
    try {
      const result = await axios.get<CustomerInvoice>(`customer-invoices/${this.invoiceId}`)
      setTimeout(() => {
        this.loading = false
        this.invoice = result.data
      }, 200)
    } catch (error: any) {
      this.loading = false
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }

  downloadInvoice() {
    downloadFile(`${axios.defaults.baseURL}/customer-invoices/${this.invoiceId}/invoice/download`)
  }

  downloadReceipt() {
    downloadFile(`${axios.defaults.baseURL}/customer-invoices/${this.invoiceId}/receipt/download`)
  }

  checkRefundStatus() {
    this.refundModal.open(this.invoice?.refundStatus || null)
  }

  async refundInvoice() {
    if (!this.invoice) {
      return
    }
    try {
      await axios.put(`customer-invoices/${this.invoiceId}/refund?ignoreWarnings=true`)
      this.invoice.status = 'refunded'
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        this.$store.dispatch('error', error.response.data.message)
      }
    }
  }
}
